// Live's bulk bar (#668, spec S1c, design-ref/library-bulk-668 04 to 07): from two checked files,
// never for one, fixed 70 px above the bottom and centred. "N selected", then Move to project,
// Download and Delete, live's ⋯ "More actions" with Re-index alone (05; spec S3, while semantic
// search is on), and × Unselect all.
import { ActionIcon, Group, Menu, Text, Tooltip } from "@mantine/core";
import { Download, Ellipsis, FolderInput, Search, Trash2, X } from "lucide-react";
import type { ReactNode } from "react";

import classes from "./library.module.css";

export interface BulkBarProps {
  count: number;
  /** A bulk action is running: its button spins and the others wait. */
  busy: "download" | "delete" | "reindex" | null;
  onMove: () => void;
  onDownload: () => void;
  onDelete: () => void;
  /** Live's Re-index, under ⋯; none while semantic search is off. */
  onReindex?: (() => void) | undefined;
  onClear: () => void;
}

export function BulkBar(props: BulkBarProps) {
  if (props.count < 2) return null;
  const action = (label: string, icon: ReactNode, onClick: () => void, loading = false) => (
    <Tooltip label={label}>
      <ActionIcon
        variant="subtle"
        color="gray"
        aria-label={label}
        loading={loading}
        disabled={props.busy !== null && !loading}
        onClick={onClick}
      >
        {icon}
      </ActionIcon>
    </Tooltip>
  );
  return (
    <div className={classes.bulkBar} role="toolbar" aria-label="Selected files">
      <Text size="sm" fw={500} className={classes.bulkCount}>
        {props.count} selected
      </Text>
      <Group gap={8} wrap="nowrap">
        {action("Move to project", <FolderInput size={18} aria-hidden />, props.onMove)}
        {action(
          "Download",
          <Download size={18} aria-hidden />,
          props.onDownload,
          props.busy === "download",
        )}
        {action(
          "Delete",
          <Trash2 size={18} aria-hidden />,
          props.onDelete,
          props.busy === "delete",
        )}
        {props.onReindex === undefined ? null : (
          <Menu position="top" withinPortal>
            <Menu.Target>
              <Tooltip label="More actions">
                <ActionIcon
                  variant="subtle"
                  color="gray"
                  aria-label="More actions"
                  loading={props.busy === "reindex"}
                  disabled={props.busy !== null && props.busy !== "reindex"}
                >
                  <Ellipsis size={18} aria-hidden />
                </ActionIcon>
              </Tooltip>
            </Menu.Target>
            <Menu.Dropdown aria-label="More actions">
              <Menu.Item leftSection={<Search size={16} aria-hidden />} onClick={props.onReindex}>
                Re-index
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </Group>
      {action("Unselect all", <X size={18} aria-hidden />, props.onClear)}
    </div>
  );
}
